<template hidden>
  <article class="pt-32">
    <h1>Now</h1>
    <div class="mx-8 md:mx-32 xl:mx-64">
      <sub class="block mb-6">Last updated: 25th January 2026</sub>
      <ul>
        <li>
          Senior Specialist 3D Web Engineer at Magnopus. Primarily doing frontend web development with a
          specialism in WebGL.
        </li>
        <li>
          Dedicated road cyclist, approx 6000km per year. I fully service and maintain my own bikes, and often others.
        </li>
        <li>Living in Cardiff.</li>
      </ul>

      <p>"Now" page concept by <a href="https://sivers.org/nowff">Derek Sivers</a></p>
    </div>
  </article>
</template>

<script>

export default {
  name: 'NowPage',
  components: {

  },

  title() {
    return 'Now';
  },

  data() {
    return {
    };
  },
};
</script>
<style lang="scss" scoped>

</style>
